<template>

    <div class="sidebar">
        <div class="sidebar-warpper" :class="[currentValue == index +1?'current': 'hide', `sider_${index}` ,`sider_${$i18n.locale}`]"
             v-for="(data ,index) in datas[$i18n.locale]"
         :key="index">
            <a class="wall" :href="data.link" target="_blank">
                <div class="wall-img">
                    <img :src="data.img">
                </div>
                <div class="wall-box" :class="{'wall-en': $i18n.locale === 'en'}">
                    {{data.text}}
                    <p v-if="data.subText">{{data.subText}}</p>
                </div>
            </a>
            <div class="friendly-show">
                <img :src="data.footer">
            </div>
        </div>
        <div class="dot-box" v-if="$i18n.locale !== 'en'">
            <div class="dot-inner">
                <div v-for="(item,index) in datas[$i18n.locale]" :class="{active: index+1 == currentValue}" @click="dosEvent(index+1)"
                     class="normal-dot" :key="index"></div>
            </div>
        </div>

    </div>
</template>

<script>
import footerSvg_ch from "assets/img/footer-zh.png";
import footerWhite from 'assets/img/footer-white.png'
import banner1 from 'assets/img/banner1.png';
import banner2 from "assets/img/banner2.png";
import banner3 from "assets/img/banner3.png";
import footerSvg_en from "assets/img/footer-en.png";
import sensebot_en from "assets/img/banner_en.png";
import {mapState} from 'vuex'
    export default{
        data(){
            return{
                wall1: true,
                wall2:false,
                currentValue: this.value,
                autoplay:true,
                datas:{
                    en:[
                        {
                            img:sensebot_en,
                            link :'https://www.geetest.com/en/adaptive-captcha',
                            footer: footerSvg_en
                        }
                    ],
                    zh:[
                        {
                            img:banner1,
                            link :'https://www2.geetest.com/adaptive-captcha',
                            footer: footerWhite
                        },
                        {
                            img: banner2,
                            link:'https://www.geetest.com/one-login-identify',
                            footer: footerWhite
                        },
                        {
                            img: banner3,
                            link:'https://www2.geetest.com/brde',
                            footer: footerWhite
                        }
                    ]
                },
            }
        },
        props:{
            value :{
                default : 1,
                type: Number
            },
        },
        methods: {
            setAutoplay () {
                window.clearInterval(this.timer);
                if (this.autoplay && this.language !== 'en') {
                    this.timer = window.setInterval(() => {
                        this.add(1);
                    }, 5000);
                }
            },
            add(offset) {
                let slidesLen = 3;
                let oldIndex = this.currentValue + offset;
                if(oldIndex >0 &&oldIndex <= slidesLen){
                    this.currentValue = oldIndex
                }
                else {
                    this.currentValue = 1
                }
            },
            dosEvent(e) {
                this.currentValue = e;
                this.setAutoplay()
            },
            clearAutoplay(){
                window.clearInterval(this.timer);
                this.autoplay = false
            }
        },
        computed:{
            ...mapState({
                language: state => state.Gtlang
                })
        },
        components:{
        },
        watch:{
            value(val) {
                this.currentValue = val;
            },
            language(val){
               if(val === 'en'){
                   this.clearAutoplay();
                   this.currentValue = 1;
               }else{
                   this.setAutoplay()
               }
            }
        },
        mounted() {
            this.setAutoplay()
        }

    }





</script>
<style rel="stylesheet/less" lang="less" scoped>
    .sidebar {
        width: 420px;
        position: relative;
        .sidebar-warpper {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            bottom: 0;
            background-color: #EDF1F5;
            &.sider_0 {
                background-color:rgba(56, 115, 255, 1);
            }
            &.sider_1 {
                background-color:rgba(87, 60, 211, 1);
            }
            &.sider_2 {
                background-color: rgba(56, 115, 255, 1);
            }
            &.sider_en {
                background-color: #edf1f5 !important;
            }
        }
    }

    @media screen and (max-height: 580px) {
        .wall-box {
            display: none;
            transition: all .3s ease;
        }
        .wall-img img {
            width: 420px;
        }
    }
    @media screen and(max-height: 700px) {
        .friendly-show {
            display: none;
        }
    }

    .wall {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        color: #3B426B;
        flex-direction: column;
        @diff: 130px;
        height: calc(~"100% - @{diff}");
        .wall-img{
            text-align: center;
            img {
                width: 420px;
            }
        }
        .wall-box {
            width: 320px;
            text-align: center;
            min-height: 60px;
        }
        .wall-icon {
            margin-top: 6%;
            margin-bottom: 4%;
        }
    }
    .wall-en{
        font-size: 16px;
    }
    .wall:hover{
        color: #3B426B;
    }

    .friendly-show {
        position: fixed;
        bottom: 144px;
        width: 420px;
        height: 32px;
        padding: 0 24px;
        z-index: 20;
        img {
            width: 100%;
        }
    }

    .dot-box {
        position: fixed;
        bottom: 24px;
        width: 420px;
        text-align: center;
        z-index: 20;
        .dot-inner {
            margin: auto;
            .normal-dot {
                border-radius: 50%;
                width: 6px;
                height: 6px;
                display: inline-block;
                background:white;
                margin: 0 2px;
                transition: all .9s ease;
                cursor: pointer;
                opacity: 0.6;
            }
            .white-dot {
                background: white;
            }
            .active {
                width: 14px;
                border-radius: 54px;
                transition: all .9s ease;
                opacity:1;
            }
        }
    }

    .active {
        background-color: black;
    }

    .current {
        z-index: 20;
        opacity: 1;
        transition: all .9s cubic-bezier(0.25, 0.1, 0.9, 0.24);
        // display: inline-block;
        // animation: pop-show .4s cubic-bezier(0.25, 0.1, 0.9, 0.24);
    }

    .hide {
        z-index: 1;
        opacity: 0.1;
        transition: all .9s ease;
        // display: none;
        // animation: pop-hide .4s ease-out;
    }

    @keyframes pop-show {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    @keyframes pop-hide {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }

</style>



// WEBPACK FOOTER //
// sidebar.vue?1f6102f1